import { AgGridReact } from 'ag-grid-react';
import moment from 'moment';
import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify';
import { grouplist, loandisburselist } from '../../../services/admin';
import { branchlist } from '../../../services/master';
import exportUrl from '../../../exportUrl';
import { deliverReport } from '../../../utils/printPdf';
import Select from "react-select";

export const LoanDisburse = () => {
    const [filterProduct, setFilterProduct] = useState([]);
    const [fdate, setFDate] = useState("");
    const [tdate, setTDate] = useState("");
    const [blist, setBlist] = useState([]);
    const [branchid, setBranch] = useState("");

    const [grpid, setGroupId] = useState("");
    const [glist, setGlist] = useState([]);
    const [mgrpid, setMGrpId] = useState("");
    useEffect(() => {
        setFDate(moment(new Date()).format("YYYY-MM-DD"));
        setTDate(moment(new Date()).format("YYYY-MM-DD"));
        funlist("", moment(new Date()).format("YYYY-MM-DD"), moment(new Date()).format("YYYY-MM-DD"),"");

        branchlist().then((res) => {
            if (res.status === true) {
                // setBlist(res.data);
                const userBranches = localStorage.getItem("branch")
                const filteredBranches = res.data.filter(branch => userBranches.includes(branch.id));
                setBlist(filteredBranches);
            }
        })
    }, []);

    const columnDefs = [

        {
            headerName: "Date",
            field: "approved_date",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
            cellRenderer: function (params) {
                if (params.value !== null) {
                    return moment(params.value).format("DD-MM-YYYY");
                }
            }
        },
        {
            headerName: "Group Name",
            field: "group_name",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Member",
            field: "member_name",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Amount",
            field: "loan_amount",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Member Sign",
            field: "",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Staff Sign",
            field: "",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "BM Sign",
            field: "",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },

        {
            headerName: "Remarks",
            field: "",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
    ];

    function handlebranch(e) {
        setBranch(e.target.value);
        funlist(e.target.value, fdate, tdate,grpid);
        if (e.target.value !== "") {
            const temp = new FormData();
            temp.append("branch", e.target.value);
            grouplist(temp).then((res) => {
                if (res.status === true) {
                    let arr = [];
                    if (res.data.length > 0) {
                        for (let i = 0; i < res.data.length; i++) {
                            arr.push({
                                value: res.data[i].id,
                                label: res.data[i].group_name
                            })
                        }
                        setGlist(arr);
                    }
                }
            })
        }

    }

    function funlist(fid, gdate, tdte,gid) {
        setFDate(gdate);
        setTDate(tdte);
        setFilterProduct([]);

        if (fid !== "" && gdate !== "" && tdte !== "") {
            const temp = new FormData();
            temp.append("branch", fid);
            temp.append("loan_date", gdate);
            temp.append("to_date", tdte);
            temp.append("group", gid);
            loandisburselist(temp).then((res) => {
                if (res.status === true) {
                    setFilterProduct(res.data);
                }
            })
        }
    }


    function handlegroup(e) {
        if (e !== null) {
            setMGrpId(e);
            setGroupId(e.value);
            funlist(branchid, fdate, tdate,e.value);
        } else {
            setMGrpId("");
            setGroupId("");
            funlist(branchid, fdate, tdate,"");
        }

    }

    function downloadfile(bid, gdate, hdate, dtype,gid) {
        if (bid !== "" && gdate !== "" && hdate !== "") {
           
            deliverReport(exportUrl + 'report/disbursementdownload?branch=' + bid + '&loan_date=' + gdate + '&to_date=' + hdate + '&type=' + dtype + '&group=' + gid, dtype);
        } else {
            toast.error("Please Select Branch");
        }
    }
    return (
        <div>
            <div className="page-header">
                <h2 className="main-content-title tx-24 mg-b-5">Loan Disbursement</h2>
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <a>Reports</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                        Loan Disbursement
                    </li>
                </ol>

            </div>


            <div className="content-body">
                <div className="row">
                    <div className="col-xl-12">
                        <div className="card">
                            <div className="card-header">
                                <h2 className="main-content-title tx-24 mg-b-5">
                                    Loan Disbursement
                                </h2>
                            </div>
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-xl-3 col-sm-6">
                                        <div className="mb-6">
                                            <label className="form-label">
                                                Branch<span className="text-danger"> *</span>
                                            </label>
                                            <select className="default-select form-control wide" onChange={handlebranch} value={branchid}>
                                                <option value="" disabled>Select Branch</option>
                                                {blist.map((item, index) => {
                                                    return (
                                                        <option key={index} value={item.id}>
                                                            {item.branch_name}
                                                        </option>
                                                    );
                                                })}
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-xl-3 col-sm-6">
                                        <div className="mb-6">
                                            <label className="form-label">
                                                Group
                                            </label>
                                            <Select
                                                className="default-select"
                                                placeholder="Select Select Group"
                                                value={mgrpid}
                                                options={glist}
                                                onChange={handlegroup}
                                                isSearchable={true}
                                                isClearable
                                                hidden
                                            />
                                        </div>
                                    </div>
                                    <div className="col-xl-3 col-sm-6">
                                        <div className="mb-6">
                                            <label className="form-label">
                                                From Date
                                            </label>
                                            <input
                                                className="form-control"
                                                type="date"
                                                value={fdate}
                                                onChange={(e) => funlist(branchid, e.target.value, tdate,grpid)}
                                            />
                                        </div>

                                    </div>
                                    <div className="col-xl-3 col-sm-6">
                                        <div className="mb-6">
                                            <label className="form-label">
                                                To Date
                                            </label>
                                            <input
                                                className="form-control"
                                                type="date"
                                                value={tdate}
                                                onChange={(e) => funlist(branchid, fdate, e.target.value,grpid)}
                                            />
                                        </div>

                                    </div>
                                    <div className="col-xl-12 col-sm-6 mt-4">
                                        <div className='text-end'>
                                            <a className="btn btn-danger me-2" onClick={() => downloadfile(branchid, fdate, tdate, 'pdf',grpid)}>Download PDF</a>
                                            <a className="btn btn-success me-2" onClick={() => downloadfile(branchid, fdate, tdate, 'excel',grpid)}>Download Excel</a>
                                            <a className="btn btn-primary" onClick={() => downloadfile(branchid, fdate, tdate, 'print',grpid)}>Print</a>

                                        </div>

                                    </div>

                                </div>
                                <div className="ag-theme-alpine ag-style mt-2">
                                    <AgGridReact
                                        columnDefs={columnDefs}
                                        rowData={filterProduct}
                                        pagination="true"
                                        paginationPageSize="10"
                                        sortingOrder={["asc", "desc"]}
                                        suppressDragLeaveHidesColumns={true}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
